import { Routes } from '@angular/router';
import { authGuard } from './core/auth.guard';

export const routes: Routes = [
  // Public login page.
  {
    path: 'login',
    loadComponent: () => import('./features/auth/login.component').then((m) => m.LoginComponent),
  },

  // Journey is the default landing page (auth-gated like everything else).
  { path: '', pathMatch: 'full', redirectTo: 'journey' },
  {
    path: 'studio',
    canActivate: [authGuard],
    loadComponent: () => import('./features/studio/studio.component').then((m) => m.StudioComponent),
  },
  {
    path: 'journey',
    canActivate: [authGuard],
    loadComponent: () => import('./features/journey/journey.component').then((m) => m.JourneyComponent),
  },
  {
    path: 'persistency',
    canActivate: [authGuard],
    loadComponent: () => import('./features/persistency/persistency.component').then((m) => m.PersistencyComponent),
  },
  { path: '**', redirectTo: 'journey' },
];
